import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/Home.css";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import ProductCard from "../components/ProductCard";

import offersData from "../data/offersData";
import safetyTipsData from "../data/safteyTipsData";
import productsData from "../data/productsData";
import OfferCard from "../components/OfferCard";
import SafetyTipCard from "../components/SafetyTipCard";

// Countdown Component
const Countdown = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState({});

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance < 0) {
        clearInterval(interval);
        setTimeLeft({});
      } else {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  if (!timeLeft.days && !timeLeft.hours) return null;

  return (
    <div className="home-countdown" role="timer" aria-live="polite" aria-atomic="true">
      <p>
        Diwali starts in:{" "}
        <span>{timeLeft.days}d</span> : <span>{timeLeft.hours}h</span> :{" "}
        <span>{timeLeft.minutes}m</span> : <span>{timeLeft.seconds}s</span>
      </p>
    </div>
  );
};

// Trending Products Carousel
const TrendingCarousel = () => {

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0px",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerMode: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
    ],
  };


  return (
    <Slider {...settings}>
      {offersData.offerData.slice(0, 3).map((offer, index) => (
        <OfferCard key={index} offer={offer} phoneNumber={offersData.contact.phoneNumber} />
      ))}
    </Slider>
  );
};

// Home Page Component
const Home = () => {
  const diwaliDate = new Date("2025-10-21T00:00:00").getTime();

  return (
    <main className="home-page">
      {/* Hero Section */}
      <section className="hero-banner home-container home-text-center">
        <h1>Light Up Your Diwali with Prini Crackers!</h1>
        <p className="tagline home-text-light">Safe, Genuine & Festive Crackers for an Unforgettable Celebration</p>
        <Link to="/products" className="home-btn home-btn-primary">Shop All Crackers</Link>
        <Countdown targetDate={diwaliDate} />
        <p className="booking-note home-text-muted">
          🎉 Diwali Booking Started! 80% Discount Offer <br />
        </p>
      </section>

      {/* Special Offers Section (formerly Trending Products) */}
      <section className="offers-section home-container home-text-center">
        <h2 className="home-heading">Grab The Best Diwali Offers!</h2>
        <div className="trending-carousel-container">
          <TrendingCarousel />
        </div>
        <Link to="/offers" className="home-btn home-btn-primary mt-4">See All Offers</Link>
      </section>


      {/* Safety Tips Section */}
      <section className="safety-tips-section home-container home-text-center">
        <h2 className="home-heading">Stay Safe This Diwali</h2>

        <div className="tips-grid">
          {safetyTipsData.slice(0, 3).map((tip, idx) => (
            <SafetyTipCard key={idx} {...tip} />
          ))}
        </div>
        <Link to="/safety-tips" className="home-btn home-btn-primary mt-4">See All Safety Tips</Link>
      </section>

      {/* Trending Products Section (formerly Special Offers) */}
      <section className="products-section home-container home-text-center">
        <h2 className="home-heading">Trending Crackers</h2>
        <div className="product-grid">
          {productsData.slice(0, 3).map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
        <Link to="/products" className="home-btn home-btn-primary mt-4">See More Products</Link>
      </section>
    </main>
  );
};

export default Home;
